import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-debug',
  standalone: true,
  imports: [MatButtonModule],
  template: `
    <div style="padding: 20px;">
      <h2>Debug információk</h2>
      <div style="margin: 10px 0;">
        <strong>Token jelen van:</strong> {{ hasToken }}
      </div>
      <div style="margin: 10px 0;">
        <strong>Token hossza:</strong> {{ tokenLength }}
      </div>
      <div style="margin: 10px 0;">
        <strong>Token első 100 karakter:</strong><br>
        <code style="word-break: break-all;">{{ tokenPreview }}</code>
      </div>
      <div style="margin: 10px 0;">
        <strong>User Data:</strong><br>
        <pre>{{ userDataString }}</pre>
      </div>
      <div style="margin: 10px 0;">
        <strong>Is Authenticated:</strong> {{ isAuthenticated }}
      </div>
      <button mat-raised-button color="warn" (click)="clearStorage()">
        Töröld a localStorage-t
      </button>
      <button mat-raised-button color="primary" (click)="refreshData()" style="margin-left: 10px;">
        Frissítsd az adatokat
      </button>
    </div>
  `
})
export class DebugPage implements OnInit {
  hasToken = false;
  tokenLength = 0;
  tokenPreview = '';
  userDataString = '';
  isAuthenticated = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.refreshData();
  }

  refreshData() {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('token');
      const userData = localStorage.getItem('userData');
      
      this.hasToken = token !== null;
      this.tokenLength = token?.length || 0;
      this.tokenPreview = token?.substring(0, 100) || 'Nincs token';
      this.userDataString = userData || 'Nincs user data';
      this.isAuthenticated = this.authService.isAuthenticated();
    }
  }

  clearStorage() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      this.refreshData();
    }
  }
}
